export class User {
    id:number;
    name: string;
    surname: string;
    login: string;
}


// WEBPACK FOOTER //
// ./src/app/models/user.ts